import React from 'react';
import { range } from 'lodash';

import { PageNumbers } from './page-numbers.component';

type PagesProps = {
  pageIndex: number;
  pageSize: number;
  totalCount?: number;
  onPageClick: (value: number) => void;
};

export const Pages = ({
  pageIndex,
  pageSize,
  totalCount,
  onPageClick,
}: PagesProps) => {
  const numPages = Math.ceil((totalCount ?? 0) / pageSize);
  const pages = totalCount !== undefined ? range(1, numPages + 1) : [];
  const getFocusLeftIndex = () => {
    if (pageIndex === 0) {
      return 0;
    } else if (pageIndex === numPages - 1) {
      return numPages - 3;
    } else {
      return pageIndex - 1;
    }
  };

  if (numPages > 5) {
    return (
      <>
        <PageNumbers
          pageIndex={pageIndex}
          pages={pages.slice(0, Math.min(getFocusLeftIndex(), 2))}
          onPageClick={onPageClick}
        />
        {pageIndex > 3 && <div>...</div>}
        <PageNumbers
          pageIndex={pageIndex}
          pages={pages.slice(getFocusLeftIndex(), getFocusLeftIndex() + 3)}
          onPageClick={onPageClick}
        />
        {pageIndex + 2 < numPages - 2 && <div>...</div>}
        <PageNumbers
          pageIndex={pageIndex}
          pages={pages.slice(
            Math.max(getFocusLeftIndex() + 3, numPages - 2),
            numPages
          )}
          onPageClick={onPageClick}
        />
      </>
    );
  }

  return (
    <PageNumbers
      pageIndex={pageIndex}
      pages={pages}
      onPageClick={onPageClick}
    />
  );
};
